import Address from './Address.component';

export default Address;
